import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from 'components/forms/new/formikFormFields/BooleanToggle';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const SBCActiveToggle = ({ darkMode, values, setFieldValue }) => (
    <FormControl sx={{ margin: '0 !important' }}>
        <Stack
            direction="row"
            spacing={stackSpacing}
            sx={{ ...stackStyling(), height: 'auto' }}>
            <FormLabel sx={formLabelStyling(darkMode, true)}>Active</FormLabel>
            <Field
                name="isActive"
                component={BooleanToggle}
                isChecked={values?.isActive ?? true}
                onChange={(value) => setFieldValue('isActive', value)}
            />
        </Stack>
    </FormControl>
);

export default SBCActiveToggle;
